<template>
  <layout-registrar-producto width="320" v-if="producto" :routeBack="{ name: 'admin.productosHome' }">
   
    <template v-slot:title>
      <v-img
        src="require('@/assets/no-image.png')"
        aspect-ratio="1"
        height="200"
        contain
        class="rounded-lg"
        style="object-fit: contain;"
      />
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <div style="font-size: 20px" class="text-wrap">
              <b>{{ producto.descripcion_global }}</b>
            </div>
          </v-list-item-title>
          <v-list-item-subtitle class="mt-1">
            Actualizado el
            {{ moment(producto.fechaActualizacion).format("ll") }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item-group mandatory>
        <v-list>
          <v-list-item
            :to="{
              name: 'gestionProductosEmpresaItemDetalle',
            }"
          >
            <v-list-item-icon>
              <v-icon>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Detalles </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :to="{
              name: 'productosEnSucursales',
            }"
          >
            <v-list-item-icon>
              <v-icon>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Sucursales </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Inventario </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click.stop="">
            <v-list-item-icon>
              <v-icon>mdi-chart-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Analytics </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="producto.parent && configuracion.productosFraccionados"
          >
            <v-list-item-content>
              <v-list-item-title>
                <div class="text-wrap">Es producto de</div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>
                  <span
                    ><a @click="changeParam(producto.parent)">
                      {{ producto.parent_name.toUpperCase() }}</a
                    ></span
                  ></b
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>

      <v-divider></v-divider>

      <v-divider></v-divider>
    </template>
    <template v-slot:navigation-controller> </template>

  

    <template v-slot:vista-previa>
      <v-container v-if="!loadingFetch">
        <router-view
          :productoProp="producto"
          @refresh-producto="fetchProducto($route.params.id_producto)"
        ></router-view>
      </v-container>
    </template>
  </layout-registrar-producto>
</template>
  
<script>

import LayoutRegistrarProducto from "@/layouts/productos/layout.registrar.producto";


import {  mapState } from "vuex";
import ProductosAPI from "@/api/productos";

export default {
  name: "ProductoEmpresaLayout",
  components: {
      LayoutRegistrarProducto,

  },

  data() {
    return {
      loadingFetch: false,
      producto: null,
      loadingProductosFraccionados: false,
      productosFraccionados: null,
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
  },

  methods: {

    fetchProductosFraccionados(producto_id) {
      this.loadingProductosFraccionados = true;

      ProductosAPI.showProductosFraccionados(producto_id)
        .then((response) => {
          this.productosFraccionados = response.data;
          this.loadingProductosFraccionados = true;
        })
        .catch((e) => {
          console.log(e);

          this.loadingProductosFraccionados = false;
        });
    },

  



    fetchProducto(id) {
      this.loadingFetch = true;

      ProductosAPI.show_empresa(id).then((response) => {
        this.producto = response.data;
        this.producto.categoriaArbol
          ? null
          : (this.producto.categoriaArbol = { id: null });
        this.loadingFetch = false;
      });
    },
    changeParam(id) {
      this.$router.replace({ name: "productoHome", params: { id: id } });
      this.fetchProducto(id);
      this.fetchProductosFraccionados(id);
    },
  },
  created() {

    if (this.$route.params.producto === undefined) {
      this.fetchProducto(this.$route.params.id_producto);
      this.fetchProductosFraccionados(this.$route.params.id_producto);
    } else {
      this.loadingFetch = true;
      var producto = this.$route.params.producto;
      if (!producto.categoriaArbol) {
        producto.categoriaArbol = { id: null };
      }


      producto.categoriaArbol = producto.categoriaArbol
        ? producto.categoriaArbol
        : { id: null };
      this.producto = producto;
      this.fetchProductosFraccionados(producto.id);

      this.loadingFetch = false;
    }
  },
};
</script>
  
<style scoped>

</style>
  